import type { FruitProductId } from "../types";

export interface FruitProductDefinition {
  readonly productId: FruitProductId;
  readonly labelKo: string;
  readonly officialSellerCount: number;
}

export const FRUIT_PRODUCTS: readonly FruitProductDefinition[] = [
  { productId: "APPLE", labelKo: "사과", officialSellerCount: 4 },
  { productId: "GRAPE", labelKo: "포도", officialSellerCount: 4 },
  { productId: "KOREAN_MELON", labelKo: "참외", officialSellerCount: 4 },
  { productId: "TANGERINE", labelKo: "감귤", officialSellerCount: 4 },
  { productId: "STRAWBERRY", labelKo: "딸기", officialSellerCount: 5 },
  { productId: "WATERMELON", labelKo: "수박", officialSellerCount: 5 },
] as const;

export const OFFICIAL_FRUIT_RIGHT_PAIRS: readonly (readonly [
  FruitProductId,
  FruitProductId,
])[] = [
  ["APPLE", "STRAWBERRY"],
  ["APPLE", "STRAWBERRY"],
  ["APPLE", "WATERMELON"],
  ["APPLE", "WATERMELON"],
  ["GRAPE", "STRAWBERRY"],
  ["GRAPE", "STRAWBERRY"],
  ["GRAPE", "WATERMELON"],
  ["GRAPE", "WATERMELON"],
  ["KOREAN_MELON", "TANGERINE"],
  ["KOREAN_MELON", "TANGERINE"],
  ["KOREAN_MELON", "TANGERINE"],
  ["KOREAN_MELON", "TANGERINE"],
  ["STRAWBERRY", "WATERMELON"],
] as const;
